import React from "react";
import { Grid, GridColumn, GridRow } from "sprint-common-web";

import { isSubtitleFileRecordDetails } from "../../../../common/file-record-details/FileRecordDetails";
import { useFileRecordDetailsState } from "../../hooks/useFileRecordDetailsState";
import { FileRecordNotesSection } from "../notes/FileRecordNotesSection";
import { FileRecordBuzzSection } from "./buzz/FileRecordBuzzSection";
import { FileRecordContentSection } from "./content/FileRecordContentSection";
import { FileRecordLanguagesSection } from "./languages/FileRecordLanguagesSection";
import { FileRecordLibrarySection } from "./library/FileRecordLibrarySection";
import { FileRecordTechnicalSection } from "./technical/FileRecordTechnicalSection";

export const FileRecordDetailsSection = (): JSX.Element => {
    const { fileRecordDetails } = useFileRecordDetailsState();

    return (
        <Grid>
            <GridRow>
                <GridColumn sm={7}>
                    <FileRecordLibrarySection />
                </GridColumn>
                <GridColumn sm={5}>
                    <FileRecordContentSection />
                </GridColumn>
            </GridRow>
            <GridRow>
                <GridColumn sm={8}>
                    <FileRecordTechnicalSection />
                </GridColumn>
                <GridColumn sm={isSubtitleFileRecordDetails(fileRecordDetails) ? 12 : 4}>
                    <FileRecordBuzzSection />
                </GridColumn>
            </GridRow>
            <GridRow>
                <GridColumn sm={6}>
                    <FileRecordLanguagesSection />
                </GridColumn>
                <GridColumn sm={6}>
                    <FileRecordNotesSection />
                </GridColumn>
            </GridRow>
        </Grid>
    );
};
